<template>
  <!-- BEGIN: Main Menu-->
  <div
    class="main-menu menu-fixed menu-light menu-accordion menu-shadow"
    data-scroll-to-active="true"
  >
    <div class="navbar-header">
      <ul class="nav navbar-nav flex-row">
        <li class="nav-item mr-auto">
          <a class="navbar-brand">
            <span class="brand-logo">
              <!--            <img width="" src="https://vaultspay.ae/public/images/logos/1532175849_logo.png">-->
            </span>
            <h2 class="brand-text">
              <img
                width="150"
                :src="`${publicPath}app-assets/logo/vaults_logo.png`"
              />
            </h2>
            <!--<h2 v-if="hidebar" >
              <span class="brand-logo">
                <img
                  width=""
                  src="https://vaultspay.ae/public/images/logos/1532175849_logo.png"
                />
              </span>
            </h2>-->
          </a>
        </li>
        <li class="nav-item nav-toggle">
          <a
            @click="hideBar = !hideBar"
            class="nav-link modern-nav-toggle pr-0"
            data-toggle="collapse"
            ><i
              class="d-block d-xl-none text-primary toggle-icon font-medium-4"
              data-feather="x"
            ></i
            ><i
              class="d-none d-xl-block collapse-toggle-icon font-medium-4  text-primary"
            >
            </i
          ></a>
        </li>
      </ul>
    </div>
    <div class="shadow-bottom"></div>
    <div class="main-menu-content">
      <ul
        class="navigation navigation-main mt-2"
        id="main-menu-navigation"
        data-menu="menu-navigation"
      >
        <!--<li class=" nav-item">-->
        <!--<a
            class="d-flex align-items-center"
            href="javascript:void(0)"
            @click="route('index')"
            ><i data-feather="home"></i
            ><span class="menu-title text-truncate" data-i18n="Dashboards"
              >Dashboards</span
            ></a
          >
        </li>-->
        <template v-for="(featureItem, featureIndex) in featureList">
          <li class="navigation-header ">
            <span class="menu-title text-truncate">{{ featureItem.name }}</span>
          </li>
          <li
            class="nav-item "
            :class="feature.slug.toLowerCase() == currentRoute ? 'active' : ''"
            v-for="(feature, index) in featureItem.features"
          >
<!--            <a-->
<!--              class="d-flex align-items-center"-->
<!--              href="javascript:void(0)"-->
<!--              @click="route(feature.slug)"-->
<!--            >-->
              <router-link class="d-flex align-items-center" :to="{name:feature.slug}">
              <i
                class="d-none d-xl-block collapse-toggle-icon font-medium-4"
                style="    margin-top: -4%;"
                v-if="feature.web_icon == null"
                ><feather type="file-text"></feather
              ></i>
              <img v-else :src="feature.web_icon" width="24" height="24" style="margin-right: 1.1rem" />
              <span class="menu-title text-truncate " data-i18n="Email">{{
                feature.name
              }}</span>
<!--            </a>-->
              </router-link>
          </li>
        </template>
        <!--<li class=" navigation-header">
          <span data-i18n="Apps &amp; Pages">Apps &amp; Pages</span
          ><i data-feather="more-horizontal"></i>
        </li>
        <li
          class=" nav-item"
          v-for="(featureItem, featureIndex) in featureList"
          :key="featureIndex"
        >
          <a
            class="d-flex align-items-center"
            href="javascript:void(0)"
            @click="route(featureItem.slug)"
          >
            <i v-if="featureItem.icon == null" data-feather="file-text"></i>
            <i v-else><img :src="featureItem.icon" height="18" width="16"/></i>
            <span class="menu-title text-truncate" data-i18n="Email">{{
              featureItem.name
            }}</span>
          </a>
        </li>-->
        <!--</li>-->
      </ul>
    </div>
  </div>
  <!-- END: Main Menu-->
</template>

<script>
export default {
  mounted() {
    this.currentRoute = this.$route.meta.activeTabKey
    this.sendCall();
  },
  data() {
    return {
      loader: false,
      featureList: [],
      hideBar: false,
      currentRoute : ''
    };
  },
  methods: {
    route(slug = "currency") {
      if (this.$route.name !== slug) {
        this.$router.push({ name: slug });
      }
    },
    sendCall() {
      let alreadyStoreFeatureList = this.$store.getters.getByKey(
          "adminFeatureList"
      );
      if(alreadyStoreFeatureList){
        this.featureList = alreadyStoreFeatureList.data
        return
      }
      this.makeRequest(
        "post",
        "v1/get-admin-dashboard-feature",
        {},
        {},
        false,
        false
      ).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.featureList = callResponse.response.data.data;
          }
        }
      });
    },

  },
  watch:{
    $route (to, from){
      if(to.meta.activeTabKey == 'adapt'){
        this.currentRoute =  from.meta.activeTabKey
      }else{
        this.currentRoute = to.meta.activeTabKey
      }
    }
  }
};
</script>
